// Load lại danh sách nhạc chờ
export const loadPl = () => {
    return {
        type: "LOAD_PLAYLIST",
    }
}